import React from "react";
import LoginForm from "../components/login/LoginForm";
import LoginHeaderImage from "../components/login/LoginHeaderImage";
import LoginHeaderTitle from "../components/login/LoginHeaderTitle";

type Props = {};

const Login = (props: Props) => {
  return (
    <div className="login-container">
      <div className="login-content">
        <LoginHeaderImage />
        <LoginHeaderTitle />
        <LoginForm />
      </div>
    </div>
  );
};

export default Login;
